import React, { useState, useEffect } from "react";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import styles from "./SubMapping.module.css";
import { getPurchaseSubmappingCurrency } from "../../../../Bookclosure/Services/ApiHandler";

export default function Currency({ PurchaseID, onMappingChange }) {
  const [columnOptions, setColumnOptions] = useState([]);
  const [currencyFields, setCurrencyFields] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});

  const handleFieldChange = (fieldId, value) => {
    setSelectedValues((prev) => {
      const updated = { ...prev, [fieldId]: value };
      onMappingChange(updated);
      return updated;
    });
  };

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const res = await getPurchaseSubmappingCurrency(PurchaseID);
        const { fields, labelList } = res.data;

        const transformedFields = (fields || []).map((currency) => ({
          id: currency.toLowerCase(),
          label: currency,
          type: "dropdown",
        }));

        setColumnOptions(labelList || []);
        setCurrencyFields(transformedFields);

        const initialState = {};
        transformedFields.forEach((field) => {
          initialState[field.id] = "";
        });

        setSelectedValues(initialState);
        onMappingChange(initialState);

      } catch (err) {
        console.error("GET Currency error:", err);
      }
    };

    fetchCurrencyData();
  }, [PurchaseID]);

  return (
    <div className={styles.formGroup}>
      {currencyFields.map((field) => (
        <CustomDropdown
          key={field.id}
          label={field.label}
          value={selectedValues[field.id] || ""}
          onChange={(value) => handleFieldChange(field.id, value)}
          options={columnOptions}
          placeholder="Map Column"
        />
      ))}
    </div>
  );
}